// import axios from "axios";

// const API = axios.create({
//   baseURL: "http://localhost:8000",
//   // baseURL: "https://app.kevmarkinvestments.com",

//   withCredentials: true,
// });

// const refreshApi = axios.create({
//   baseURL: "http://localhost:8000",
//   // baseURL: "https://app.kevmarkinvestments.com",

//   withCredentials: true,
// });

// export default API;
// export { refreshApi };

// // for deploying use this
import axios from "axios";

const API = axios.create({
  baseURL: "https://app.kevmarkinvestments.com/api",
  withCredentials: true,
});

const refreshApi = axios.create({
  baseURL: "https://app.kevmarkinvestments.com/api",
  withCredentials: true,
});

export default API;
export { refreshApi };

// // import axios from "axios";

// // const API = axios.create({
// //   baseURL: "https://app.kevmarkinvestments.com",

// //   withCredentials: true,
// // });

// // const refreshApi = axios.create({
// //   baseURL: "https://app.kevmarkinvestments.com",

// //   withCredentials: true,
// // });

// // export default API;
// // export { refreshApi };
